/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import PropTypes from 'prop-types';

import {NotImplemented} from '@amblique/contentful/app/components/contentful/not-implemented';

/**
 * Carousel component
 * Override this component in your package to provide custom implementation.
 *
 * @param {Object} props - Component props
 * @param {Contentful.Carousel} props.component - Carousel component data
 * @param {boolean} [props.isComplete] - Whether component has all fields
 * @param {boolean} [props.isFetching] - Whether additional data is being fetched
 * @returns {React.ReactElement}
 */
export const Carousel = ({component, isComplete = true, isFetching = false, ...props}) => {
  return (
    <NotImplemented component={component} isComplete={isComplete} isFetching={isFetching} {...props} />
  );
};

Carousel.displayName = 'Carousel';
Carousel.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
};
